import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3A8D45DA-5897-4B18-BDA5-951967BD4CF8
 * name image-filter-center-focus-strong
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-center-focus-strong.svg
 * tags
 * - Photography 
 */
export const ImageFilterCenterFocusStrongIcon = createSvgIcon(<><path d="M12 8C8.44 8 6.65 12.31 9.17 14.83C11.69 17.35 16 15.56 16 12C16 9.79 14.21 8 12 8M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5M19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19" /></>, 'ImageFilterCenterFocusStrongIcon');
export default ImageFilterCenterFocusStrongIcon